import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { getPageLink } from "utils";
import { Icon, InPlaceEditingPlaceholder } from "components";
import type { IconName } from "components/Icon/iconNames";

import {
  useGetWidgetTitleByType,
  useGetWidgetDescriptionsByType,
} from "hooks/useRecentProjectsLinkWidgetHelper";
import styles from "./RecentProjectsLinkWidget.module.scss";

interface RecentProjectsLinkWidgetProps {
  widget?: Scrivito.Widget;
  getData?: () => string;
}

Scrivito.provideComponent(
  "RecentProjectsLinkWidget",
  ({ widget, getData }: RecentProjectsLinkWidgetProps) => {
    if (!widget) return null;
    const link = widget.get("link") as Scrivito.Link | null;
    const widgetType = widget.get("widgetType") as string;
    const title = useGetWidgetTitleByType(widgetType);
    const descriptions = widget.get("withProjectCountDescription")
      ? [getData!()]
      : useGetWidgetDescriptionsByType(widgetType);
    const iconName =
      widget.get("withIcon") && (widget.get("iconName") as IconName);

    if (!link) {
      return (
        <InPlaceEditingPlaceholder>
          Link should be provided
        </InPlaceEditingPlaceholder>
      );
    }

    return (
      <Scrivito.LinkTag
        data-testid={`RecentProjectLinkWidgetComponent_all-projects-link--${iconName}`}
        to={getPageLink(link)}
        className={cx(
          "d-flex cursor-pointer ps-6 pe-5 align-items-center justify-content-between text-decoration-none position-relative w-100",
          styles.wrapper,
        )}
      >
        <div className="d-flex flex-nowrap align-items-center">
          {iconName && (
            <Icon
              iconName={iconName}
              className="icon-64 me-4"
              data-testid="icon"
            />
          )}
          <div className="d-flex flex-column">
            <h3 className="text-uppercase mb-1">{title}</h3>
            <div className="d-flex flex-wrap">
              {(descriptions as string[]).map((label, key) => (
                <h4 key={key} className="d-flex flex-nowrap mb-0">
                  <div className="text-nowrap">{label}</div>
                  <div className="mx-1">
                    {descriptions.length !== 1 &&
                      descriptions.length !== key + 1 &&
                      "|"}
                  </div>
                </h4>
              ))}
            </div>
          </div>
        </div>
        <Icon iconName="chevron-right-regular" className="icon-40" />
      </Scrivito.LinkTag>
    );
  },
);
